import React, { useEffect, useState } from "react";
import "./Login.css";
import Buttons from "../../../components/ButtonsComp";
import { useNavigate, useParams } from "react-router-dom";
import PageURL from "../../../constants/PageURL";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import {
  clear_errors,
  FORGOT_PASSWORD_RESET,
  RESET_PASSWORD_RESET,
  send_otp_reset,
} from "../../../constants/dataConstants";
import { forgotPassword, resetPassword, sendOtp } from "../../../actions/userActions";
import Loader from "../../../components/Loader";

const ResetPassword = (props) => {
  const navigate = useNavigate();
  const [password, setPassword] = useState({ new: "", confirm: "" });
  const dispatch = useDispatch();
  const { isResetPassword, resetPasswordLoading, resetPasswordError } =
    useSelector((state) => state.user);
const params=useParams()
  /* #####  Send OTP Handler for forgot password  ##### */

  const sendPasswordHandler = () => {
    // if (
    //   !username.match(
    //     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    //   )
    // ) {
    //   toast.error("Enter a valid username");
    //   return;
    // }

    /* #####  dispatch actions to send otp  ##### */

    dispatch(resetPassword(params.token,password));
  };

  useEffect(() => {
    if (resetPasswordError) {
      toast.error(resetPasswordError);
      dispatch({ type: clear_errors });
    }
    if (isResetPassword) {
      toast.success("Password saved successfully!");
      dispatch({ type: RESET_PASSWORD_RESET });
    setPassword({new:"",confirm:""})
    navigate(PageURL.BASE)
    }
  }, [navigate, dispatch, resetPasswordError, isResetPassword]);
console.log(isResetPassword)
  return (
    <div style={{ width: "100%" }} className="login-box">
      {resetPasswordLoading && <Loader />}
      <h2 style={{ textAlign: "center" }}>Forgot Password</h2>
      <div className="inputs" style={{ width: "80%" }}>
        <input
          type="text"
          placeholder="New Password"
          style={{
            textAlign: "center",
            fontWeight: "bolder",

            color: "black",
          }}
          value={password.new}
          onChange={(e) => {
            setPassword({...password, new: e.target.value });
          }}
        />
      </div>

      <div className="inputs" style={{ width: "80%" }}>
        <input
          type="text"
          placeholder="Confirm Password"
          style={{
            textAlign: "center",
            fontWeight: "bolder",

            color: "black",
          }}
          value={password.confirm}
          onChange={(e) => {
            setPassword({...password, confirm: e.target.value });
          }}
        />
      </div>
      <div style={{ flexDirection: "row" }} className="buttons">
        <Buttons
          type="contained"
          buttonType="primary"
          buttonText="Back"
          onClick={() => {
            navigate(PageURL.BASE);
          }}
        ></Buttons>
        <Buttons
          type="outlined"
          buttonType="secondary"
          buttonText="Save"
          onClick={sendPasswordHandler}
        ></Buttons>
      </div>
    </div>
  );
};

export default ResetPassword;
